var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',[_c('li',{staticClass:"flex-start"},[_c('span',[_vm._v("答题结束背景图")]),(!_vm.data.image)?[_c('el-button',{staticClass:"leading-22",attrs:{"type":"text"},on:{"click":_vm.onUploadImage}},[_vm._v("上传图片")])]:[_c('image-box',{attrs:{"src":_vm.data.image},on:{"remove":_vm.onRemove}})]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }